module.exports = __webpack_public_path__ + "static/media/gal0111.3f2389c3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/ressources/gal01/gal0111.jpg
// module id = 367
// module chunks = 0